export default "/_next/static/images/doge-7008ccc79e0e6b2c87c5884c2d26b5f2.svg";